import { darken, transparentize } from 'polished';

import colors from './colors';

const BUTTON_TYPES = {
  DEFAULT: 'DEFAULT',
  OUTLINED: 'OUTLINED',
  FLAT: 'FLAT',
};

const getFlatButtonVariant = color => {
  return {
    color: color,
    backgroundColor: 'transparent',
    border: 'none',
    textDecoration: 'underline',
    '&:hover': {
      color: darken(0.1, color),
    },
    '&:active': {
      color: darken(0.35, color),
    },
    '&[disabled]': {
      color: transparentize(0.4, color),
      background: 'none',
      'pointer-events': 'none',
    },
  };
};

const getOutlinedButtonVariant = color => {
  return {
    color: color,
    backgroundColor: 'white',
    border: `2px solid ${color}`,
    '&:hover': {
      color: darken(0.05, color),
      borderColor: darken(0.05, color),
    },
    '&:active': {
      color: darken(0.15, color),
      borderColor: darken(0.15, color),
    },
    '&[disabled]': {
      color: transparentize(0.5, color),
      borderColor: transparentize(0.5, color),
      background: 'none',
      'pointer-events': 'none',
    },
  };
};

const getDefaultButtonVariant = color => {
  return {
    color: 'white',
    backgroundColor: color,
    border: `2px solid ${color}`,
    '&:hover': {
      backgroundColor: darken(0.05, color),
      borderColor: darken(0.05, color),
    },
    '&:active': {
      backgroundColor: darken(0.15, color),
      borderColor: darken(0.15, color),
    },
    '&[disabled]': {
      color: transparentize(0.1, 'white'),
      backgroundColor: transparentize(0.4, color),
      borderColor: 'transparent',
      'pointer-events': 'none',
    },
  };
};

const getButtonVariant = (variant, color) => {
  switch (variant) {
    case BUTTON_TYPES.FLAT:
      return getFlatButtonVariant(color);
    case BUTTON_TYPES.OUTLINED:
      return getOutlinedButtonVariant(color);
    case BUTTON_TYPES.DEFAULT:
    default:
      return getDefaultButtonVariant(color);
  }
};

const buttonStyles = {
  primary: getButtonVariant(BUTTON_TYPES.DEFAULT, colors.primary),
  primaryOutlined: getButtonVariant(BUTTON_TYPES.OUTLINED, colors.primary),
  primaryFlat: getButtonVariant(BUTTON_TYPES.FLAT, colors.primary),
  secondary: getButtonVariant(BUTTON_TYPES.DEFAULT, colors.secondary),
  secondaryOutlined: getButtonVariant(BUTTON_TYPES.OUTLINED, colors.secondary),
  secondaryFlat: getButtonVariant(BUTTON_TYPES.FLAT, colors.secondary),
};

export default buttonStyles;
